import { userDestinationsActions, userDestinationsSelectors } from '@anm/store/modules/userDestinations';
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

export const useDeleteDestination = () => {
  const dispatch = useDispatch();

  const isPending = useSelector(userDestinationsSelectors.selectDeleteDestinationPending);

  const handleDeleteDestination = useCallback((destinationId: string) => {
    dispatch(userDestinationsActions.deleteSocialDestination({ destinationId }));
  }, []);

  return [isPending, handleDeleteDestination] as const;
};
